<template>
    <div class="full-height qrcode-viewer">
        <br><br><br><br>
        <div class="qrcode-container">
            <div :class="'qrcode-inner'">
                <LoadingMini ref="loading"></LoadingMini>
                <QRCode ref="qrcode" :text="code" :size="300" :color="'#000000'" :class="{show:code != ''}"
                        :bg-color="'#FFFFFF'" :error-level="'M'"></QRCode>
            </div>
        </div>
        <div class="form-row row standard" v-show="false">
            <div class="col-12 simple-checkbox">
                <input type="checkbox" name="qrcodeComment" id="qrcodeComment" v-model="insertComment"
                       @change="toggleComment"/>
                <label for="qrcodeComment">{{ $t('ap.qrcodeComment') }}</label>
            </div>
        </div>
        <br v-show="!hasComment"><br>
        <div class="center">
            <Btn class="primary reverse" @click.native.stop="handleDownload" v-can="'beepiz-downloadQRCode-library'">
                {{ $t('ap.qrcodeDownload') }}
            </Btn>
        </div>


    </div>
</template>

<script>
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import QRCode from 'vue-qrcode-component';
    import LoadingMini from '@/components/ui/LoadingMini';

    export default {
        beforeCreate: function () {
        },
        beforeDestroy: function () {
        },
        beforeMount: function () {
        },
        beforeUpdate: function () {
        },
        components: {
            Toolbar,
            Btn,
            QRCode,
            LoadingMini
        },
        computed: {
            hasComment: function(){
                if(this.props.ap != null){
                    if(this.props.ap.comment != ""){
                        return true;
                    }
                }
                return false;
            }
        },
        created: function () {
        },
        data () {
            return {
                code: '',
                blob: null,
                insertComment: false
            }
        },
        destroyed: function () {
        },
        methods: {
            constructLink: function(serial){
                return 'https://client.beepiz.com/ap/'+serial;
            },

            handleDownload: function(){
                if(this.blob != null){
                    var newBlob = new Blob([this.blob], {type: 'image/png'})

                    // IE doesn't allow using a blob object directly as link href
                    // instead it is necessary to use msSaveOrOpenBlob
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(newBlob, 'Beepiz-QRCode - '+this.props.ap.name + ".png");
                        return;
                    }

                    // For other browsers:
                    // Create a link pointing to the ObjectURL containing the blob.
                    const data = window.URL.createObjectURL(newBlob);
                    var link = document.createElement('a');
                    document.body.appendChild(link);
                    link.href = data;
                    link.download = 'Beepiz-QRCode - '+this.props.ap.name + ".png";
                    link.click();
                    setTimeout(function () {
                        // For Firefox it is necessary to delay revoking the ObjectURL
                        window.URL.revokeObjectURL(data);
                    }, 100)
                }

            },

            toggleComment: function(){

            }
        },
        mounted: function () {
            this.$refs.qrcode.qrCode._oDrawing._elImage.onload = () => {

                this.$refs.qrcode.qrCode._oDrawing._elImage.onload = null;

                var c=this.$refs.qrcode.qrCode._oDrawing._elCanvas;

                var ctx=c.getContext("2d");
                var imageLogo = new Image();
                ctx.drawImage(this.$refs.qrcode.qrCode._oDrawing._elImage, 0, 0, 300, 300);

                imageLogo.onload = () => {
                    ctx.drawImage(imageLogo, 0, 0, 300, 300);
                    var img = c.toDataURL("image/png");
                    this.$refs.qrcode.qrCode._oDrawing._elImage.src = img;
                    if(c.toBlob) {
                        c.toBlob(
                            (blob) => {
                                this.blob = blob;
                            }
                        );
                    }
                }
                imageLogo.src = "/static/maskapqrcode.png";

            }

            this.code = this.constructLink(this.props.ap.serial);
        },
        name: '',
        props: {
            props: {
                type: Object,
                default: function () {
                    return {
                        ap: null
                    }
                }
            }
        },
        updated: function () {
        },
        watch: {
            props: function (newValue, oldValue) {

                this.$refs.qrcode.qrCode._oDrawing._elImage.onload = () => {
                    this.$refs.qrcode.qrCode._oDrawing._elImage.onload = null;

                    var c=this.$refs.qrcode.qrCode._oDrawing._elCanvas;

                    var ctx=c.getContext("2d");
                    var imageLogo = new Image();
                    ctx.drawImage(this.$refs.qrcode.qrCode._oDrawing._elImage, 0, 0, 300, 300);

                    imageLogo.onload = () => {
                        ctx.drawImage(imageLogo, 0, 0, 300, 300);
                        var img = c.toDataURL("image/png");
                        this.$refs.qrcode.qrCode._oDrawing._elImage.src = img;
                        c.toBlob(
                            (blob) => {
                                this.blob = blob;
                            }
                        );
                    }
                    imageLogo.src = "/static/maskapqrcode.png";

                }

                this.code = this.constructLink(newValue.ap.serial);
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>